import React , { useContext, useEffect, useState } from 'react'
import { Box, Button, Grid, Typography } from '@mui/material'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import "./MultipleAppointment.css";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import MultipleAppointmentDetails, { MultipleAppointmentDetailsData , mapMultipleAppointmentDetailsData} from '../../models/MultipleAppointments';
import { updateMultipleAppointments } from "../../features/MultipleAppointments/multipleAppointmentsSlice";
import MultipleAppointmentSelected, { MultipleAppointmentSelectedData, mapMultipleAppointmentSelectedData} from '../../models/MultipleAppointmentSelected';
import HashReturnObject from '../../models/HashReturnObject';
import { updateMultipleAppointmentSelected } from '../../features/MultipleAppointments/multipleAppointmentSelectedSlice';
import dayjs from 'dayjs';
import { boolean } from 'yup';
import { NavigatePage, PageName, getProperURL } from '../../utils/Util';
import useApptConfirmNav from '../hooks/useApptConfirmNav';
import { AppendLabel, Event , PageView} from '../../utils/GA';
import { updateCurrentPage } from '../../features/session/sessionSlice';
import useStateNavigation from '../hooks/useStateNavigation';
import { stateRoutes } from '../../models/Page';

function MultipleAppointments ()  {
    const Navigate = useStateNavigation()
    const dispatch = useAppDispatch()
    const state = useAppSelector(state => state)
    const [multipleAppointments,setMultipleAppointments] = useState<MultipleAppointmentDetails[]>(state.multipleAppointments.multipleAppointmentDetails);
    const [multipleSelectedAppointments,setMultipleSelectedAppointments] = useState<MultipleAppointmentSelected[]>(state.multipleAppointmentSelected.multipleAppointmentSelected);
    const [selectedAppt, setSelectedAppt] = useState({
        apptkeys: [''],
        response: [''],
      });
    

      useEffect(() => {
        dispatch(updateCurrentPage({CurrentPage :  PageName.MultipleAppointment}))  
		if ( multipleSelectedAppointments.length > 0)
        {
            const Appt: any[] = multipleSelectedAppointments
            setSelectedAppt({
                apptkeys: Appt,
                response: Appt,
              });
        }
	}, []);

    useEffect(() => {
        PageView(
            `pageview_multiple_appointments_screen`, state.session.CoverKey?.toString() ,state.session.LocKey?.toString(), state.session.AcctKey?.toString()
        )
    },[])

    //If appointment confirmation is complete, force user back to the confirmation screen
    useApptConfirmNav();

    const handleClick = ()=>{
    //GA-10
	Event(
        false,
        'click_review_appointment_multiple_appointments_screen',
        state.session.CoverKey?.toString() ,state.session.LocKey?.toString(), state.session.AcctKey?.toString()
    ) 
        
      dispatch(updateMultipleAppointmentSelected(selectedAppt.apptkeys.filter((e) => e !== '')));
      NavigatePage(dispatch,"next",state,Navigate,stateRoutes.appointmentVisitDetails)
      //const url =  getProperURL('/appointmentvisitdetails', state.embed)
      //Navigate(url)         
     // Navigate('/appointmentvisitdetails')
    }

    const SelectAppointment =  (value: string, checked: boolean) => {
        const { apptkeys } = selectedAppt;

        //GA-11
	Event(
        false,
        'click_select_appointment_multiple_appointments_screen',
        state.session.CoverKey?.toString() ,state.session.LocKey?.toString(), state.session.AcctKey?.toString()
    ) 
         
        if (checked) {
          setSelectedAppt({
            apptkeys: [...apptkeys, value],
            response: [...apptkeys, value],
          });
        }  
        else {
          setSelectedAppt({
            apptkeys: apptkeys.filter((e) => e !== value),
            response: apptkeys.filter((e) => e !== value),
          });
        }
        //console.log(seletectedAppt.apptkeys);
      };

    
      const isSelected = (AppKey: string) => {
        return selectedAppt.apptkeys.includes(AppKey);
      };

    //   const isFound = multipleSelectedAppointments.some(element => {
    //     if (element === 1) {
    //       return true;
    //     }
    
    //     return false;
    //   });
      
    return (
        <div>
            <Box
                display={"flex"}
                alignItems={"center"}
                className="wsui-header-partical"
            >
                
                <Box flexGrow={1}>
                    <Typography variant="h6"
                        fontWeight={"500"}
                        sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                        }} >
                        { state.availability.getInitialLocation.Name ?? ''}
                    </Typography>
                </Box>
                <Box sx={{}}>
                    <Typography
                        variant="h6"
                        fontWeight={"500"}
                        sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >
                        <div>{dayjs(state.availability.availability.AppointmentDateTime).format('dddd, MMMM DD')} - {dayjs(state.availability.availability.AppointmentDateTime).format('h:mm A')}</div>
                    </Typography>
                </Box>
            </Box>
            <Box borderBottom={"0.5px solid black !important"} className="wsui-box-p">
                <div className="Typogrphy-pb wsui-top-heading">
                    <div>
                        <b>{state.appointmentData.appointmentType.Name}</b>
                        {state.demographics.demographics.Config?.ProviderAgnostic === 0 ?  <span className="heading-subText"> with <b>{state.providers.provider.FirstName + ' ' + state.providers.provider.LastName + ', ' + state.providers.provider.Title ?? ''  }</b></span> : null} 
                    </div>
                </div>
            </Box>
            <div className="wsui-header-top">
                <div><label>Patient:</label> <b>{state.patient.FirstName + " " + state.patient.LastName}</b></div>
                <div><label>Email:</label> <b>{state.patient.Email ?? ''}</b></div>
            </div>
            <div className='multiple-appointment-page'>
                <div className='wsui-header-top-m d-flex booking-icon'>
                    <div className='wsui-header-text'>
                        <p className="mutiple-appointment-header">
                            <Box className="wsui-icon" sx={{mx:2}}><CalendarMonthIcon sx={{ fontSize:50}}/></Box>
                            <span className='mutiple-appointment-sub'>We've found multiple appointments for you.
                                <p className='mutiple-appointment-subheader-desktop'>
                                    We noticed that you have another appointment(s) already scheduled.
                                </p>
                            </span>
                        </p>
                        <p className='mutiple-appointment-subheader'>We noticed that you have another appointment(s) already scheduled.</p>
                    </div>
                </div>
                <p className='existing-appointment'>Existing Appointment</p>
              
            {multipleAppointments.map((item) => {
                const selected = isSelected(item.ApptKey);
                return (
                    <div key={item.ApptKey} className='mutiple-appointment-label'>
                        <div className='wsui-mainPage'>
                            <div>
                                <p className='appointmentDetials'><b>Time</b></p>
                                <p>{dayjs(item.Appointment).format('dddd, MMMM DD')} - {dayjs(item.Appointment).format('h:mm A')}</p>
                            </div>
                            <div>
                                <p className='appointmentDetials location-text'><b>Location</b></p>
                                <p>{item.LocationName}</p>
                            </div>
                            <div>
                                <p className='appointmentDetials patient-text'><b>Patient</b></p>
                                <p>{item.PatientName}</p>
                            </div>
                        </div>
                        <div className='appointmentBtn'>
                            <button className='input-cb' onClick={() => SelectAppointment(item.ApptKey, !selected)}>
                                <input
                                    id={`checkbox-remove-multiple-appt-${item.ApptKey}`}
                                    className="checkbox-remove-multiple-appt"
                                    type="checkbox"
                                    value={item.ApptKey}
                                    checked={selected}
                                />
                                <span className='warning-text'><b>Remove this Appointment</b></span>
                            </button>
                        </div>
                    </div>
            )})}
                {/* <div className='mutiple-appointment-label wsui-borderBotton'>
                    <div className='wsui-mainPage'>
                        <div>
                            <p className='appointmentDetials'><b>Day/Date/Time</b></p>
                            <p><b>Monday, Mar 6th- 11am</b></p>
                        </div>
                        <div>
                            <p className='appointmentDetials location-text'><b>Location</b></p>
                            <p>Practical Vision-Smokey Mountain-NE Aurora</p>
                        </div>
                        <div>
                            <p className='appointmentDetials patient-text'><b>Patient</b></p>
                            <p>Robert Charmichael</p>
                        </div>
                    </div>
                    <div className='appointmentBtn'>
                        <button className='input-cb'><input type="checkbox" />
                            <span><b>Remove this Appointment</b></span>
                        </button>
                    </div>
                </div> */}
                <p className='appointment-changes'>Appointment changes will not be reflected until you have fully completed booking.</p>
            </div>
            <Box className="wsui-footer-data" >
                <Grid className="wsui-text-continued">
                    <p>Choose the Appointment(s) to <b>remove,</b> or simply keep them, and move on to <b>"Review Appointment Details".</b> </p>
                </Grid>
                <Button
                    id="button-review-multiple-appt"
                    className="button-review-multiple-appt"
                    style={{
                        backgroundColor: "var(--fpc-blue)",
                        color: `${state.embed.fontColor}`,
                    }}
                    variant="contained"
                    type="submit"
                    sx={{ borderRadius: 10 }}
                    onClick={handleClick}
                >
                    <span className="wsui-submit-button">
                        Review Appointment Details
                    </span>
                </Button>
            </Box>
        </div>
    )
}

export default MultipleAppointments